/**
 * Design tokens — the values MUI's palette can't express.
 *
 * Surfaces and text are deliberately NOT here. Those must stay mode-aware, so they go through
 * the theme (`background.paper`, `divider`, `text.secondary`, `action.hover`). A hex written
 * into a component is a hex that breaks in dark mode.
 *
 * ── The seven rules ──────────────────────────────────────────────────────────────────────
 *
 * 1. Hue says WHICH, saturation says HOW IMPORTANT. They are two separate signals and
 *    conflating them is what made the old cards shout.
 *      hue:        primary blue = money · success green = discounts ·
 *                  error red = destructive · warning orange = needs attention ·
 *                  neutral = settings and utilities
 *      saturation: one solid filled control per group; everything else a soft tint of its
 *                  own hue (see CardActions). Demote by draining saturation, not by
 *                  draining color — vendors scan by color before they read the label, and
 *                  an all-grey row throws that cue away and reads as unfinished.
 * 2. No gradients, no colored drop-shadows. Flat fills only.
 * 3. No purple. Plans are a product feature, not a second brand — they use primary.
 * 4. One filled button per card. If two things look equally important, one of them isn't.
 * 5. Metadata is text, not chips. Chips are for states that must pop (ON/OFF, % off,
 *    Auto-managed) — see MetaLine for the text form.
 * 6. 44px minimum tap target; 36px for buttons packed inside a card row, 48px when those
 *    buttons stack their icon above the label.
 * 7. Never hardcode a hex the palette already has.
 */

export const RADIUS = { sm: 8, md: 12, lg: 16, pill: 999 };

// `dense` is for buttons packed into a card action row, where four have to fit across a
// 390px phone. `stacked` is that same row with the icon above the label rather than beside it,
// which is the only way four labelled icons fit that width — beside the label, an icon costs
// ~26px and "Discount" alone already fills its ~72px slot. Anything standing alone gets `min`.
export const TOUCH = { min: 44, dense: 36, stacked: 48 };

// Drag-handle gutter. Narrow enough not to indent the card, wide enough to grab.
export const GRIP_W = 32;

// Not a brand color and not a palette entry — it's WhatsApp's, and it has to stay theirs to
// be recognised. Was copy-pasted 11 times with two different hover values.
export const WHATSAPP = { main: '#25D366', hover: '#1EBE5D' };
